import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modePlagal';
const args = {};

export class ModePlagal extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
